import type { ComponentProps } from 'react'
import Svg, { Path } from 'react-native-svg'

export function History(props: ComponentProps<typeof Svg>) {
  return (
    <Svg width={63} height={63} viewBox="0 0 63 63" fill="none" {...props}>
      <Path d="M0 8a8 8 0 018-8h47a8 8 0 018 8v47a8 8 0 01-8 8H8a8 8 0 01-8-8V8z" fill="#C6FFF5" />
      <Path
        d="M20.833 18.167v26.666L23.5 43.5l2.667 1.333 2.666-1.333 2.667 1.333 2.667-1.333 2.666 1.333L39.5 43.5l2.667 1.333V18.167L39.5 19.5l-2.667-1.333-2.666 1.333-2.667-1.333-2.667 1.333-2.666-1.333L23.5 19.5l-2.667-1.333z"
        fill="#00DFC9"
        stroke="#223843"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M34.167 26.167h-8M36.833 31.5H26.167M32.833 36.833h-6.666"
        stroke="#223843"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  )
}
